module.exports = __webpack_public_path__ + "static/asurion-04f94023e80dd2d1391775a696caf45c.png";